<div class="settings-header">
  <span class="dv-icons">settings</span>
  <div>
    <h2 class="settings-header__title">
      {{ 'SettingsPage.Title' | translate }}
    </h2>
  </div>
</div>
<div class="settings-content">
  <div class="settings-content__search">
    @if (searchElement) {
      <dv-dynamic-form
        [elements]="[searchElement] | translateElements"
        [formGroup]="searchInputForm" />
    }
  </div>
  <dv-settings-list
    [settingsListItems]="settingsListItems()"></dv-settings-list>
</div>
